<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('moduletemplates.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                name="coursetype.coursetypegroup_id"
                v-model="search_params.coursetypegroup_id"
                :items="coursetypegroups"
                item-text="name"
                item-value="id"
                :label="$t('coursetypegroups.title')"
                autocomplete="new-password"
                @change="filter('reset-coursetype')"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="search_params.coursetype_id"
                :items="coursetypes"
                item-text="fullname"
                item-value="id"
                :label="$t('coursetypes.title')"
                @change="filter"
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="search_params.status"
                :items="[{ key: 'all', text: $t('global.all') }, ...$dd_module_templates_status()]"
                item-text="text"
                item-value="key"
                :label="$t('moduletemplates.status')"
                @change="filter"
                hide-details
              >
              </v-select>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/moduletemplates/create'" v-if="$can('moduletemplate-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="moduletemplates"
            :items-per-page="moduletemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.req_module_id="{ item }">
              {{ item.req_module != null ? item.req_module.name : "" }}
            </template>

            <template v-slot:item.coursetype_id="{ item }">
              {{ item.coursetype != null ? item.coursetype.name : "" }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_module_templates_status(item.status) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/moduletemplates/edit/' + item.id,
                  props: { id: item.id }
                }"
                v-if="$can('moduletemplate-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" @click="del(item.id)" v-if="$can('moduletemplate-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesList",

  data() {
    return {
      url: "",
      moduletemplates: [],

      allcoursetypes: [],
      coursetypes: [],
      coursetypegroups: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_ModuleTemplate_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        name: "",
        status: 1,
        coursetype_id: "",
        coursetypegroup_id: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("moduletemplates.name"), value: "name" },
          { text: this.$t("moduletemplates.req_hours"), value: "req_hours" },
          {
            text: this.$t("moduletemplates.req_module_id"),
            value: "req_module_id"
          },
          {
            text: this.$t("moduletemplates.coursetype_id"),
            value: "coursetype_id"
          },
          {
            text: this.$t("moduletemplates.internal_note"),
            value: "internal_note"
          },
          { text: this.$t("moduletemplates.status"), value: "status" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__filter_ModuleTemplate_List", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_ModuleTemplate_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_ModuleTemplate_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "moduletemplates"
    if (localStorage.getItem("__filter_ModuleTemplate_List")) {
      this.search_params = JSON.parse(localStorage.getItem("__filter_ModuleTemplate_List"))
    }
  },

  created() {
    this.loadDropdowns()
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_ModuleTemplate_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_ModuleTemplate_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.moduletemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    loadDropdowns() {
      let lists = [
        {
          key: "coursetypegroups",
          module: "coursetypegroups",
          query: "show_all=true&sort_by=category&sort_order=asc"
        },
        { key: "coursetypes", module: "coursetypes", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.allcoursetypes = res.data.coursetypes

        this.coursetypes = this.allcoursetypes
      })
    },

    filter(action = null) {
      if (action == "reset-coursetype") {
        this.search_params.coursetype_id = ""
      }

      if (this.search_params.coursetypegroup_id) {
        this.coursetypes = this.allcoursetypes.filter((i) => i.coursetypegroup_id == this.search_params.coursetypegroup_id)
      } else {
        this.coursetypes = this.allcoursetypes
      }

      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduletemplate/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
